import { routes as queueRoutes } from "./queue/routes";
import { routes as currentDischargeRoutes } from "./current-discharge/routes";
import { routes as admissionRoutes } from "./admissions/routes";
import { routes as admissionReportRoutes } from "./admission-report/routes";
import { routes as dischargeReportRoutes } from "./discharge-report/routes";

export const routes = [

    ...queueRoutes(),
    ...currentDischargeRoutes(),
    ...admissionRoutes(),
    ...dischargeReportRoutes(),
    ...admissionReportRoutes(),
];
